import { OpenedResponseOptionRow } from '@/components/presentation/ProjectSurveyResponses';
import { formatPlurality } from '@trinity/chat-components/utils';
import styles from './style/Matrix.Data.module.css';
import ResponseOptionUser from './ResponseOptionUser';
import type { MatrixOptionItem } from './interfaces';

type Props = {
  item: MatrixOptionItem;
  onReset: () => void;
  group: {
    value: string;
  };
};

function formatOptionSubtitle(count: number) {
  return `(${count} ${formatPlurality('Respondent', count)})`;
}

export const MatrixGroupItemData = ({ item, onReset, group }: Props) => {

  const count = item.userIds.length;
  const subtitle = formatOptionSubtitle(count);

  return (
    <>
      <div className={styles.row}>{group.value}</div>
      <OpenedResponseOptionRow
        color={item.color}
        label={item.name}
        subtitle={subtitle}
        onClose={onReset} />
      {item.userIds.map(userId => (
        <ResponseOptionUser
          key={userId}
          className={styles.user}
          userId={userId} />
      ))}
    </>
  );
};

export default MatrixGroupItemData;